import { render, staticRenderFns } from "./payment-failed.vue?vue&type=template&id=3c13518b&scoped=true&"
import script from "./payment-failed.vue?vue&type=script&lang=js&"
export * from "./payment-failed.vue?vue&type=script&lang=js&"
import style0 from "./payment-failed.vue?vue&type=style&index=0&id=3c13518b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c13518b",
  null
  
)

export default component.exports